module.exports = require("@nestjs/typeorm");